export const REDUCER_NAME = 'customer'

export const FILE_TYPE_IMAGE = 'imageList'

export const FILE_TYPE_X_RAY = 'xRayFileList'

export const FILE_TYPE_SCAN_FILE = 'scanFileList'

export const FILE_TYPE_IMPLANT_SCAN_FILE = 'implantScanFileList'

export const FILE_TYPE_IMPLANT_TREATMENT_PLAN = 'implantTreatmentPlanFileList'

export const FILE_TYPE_OTHER_FILES = 'otherFileList'

export const FILE_TYPE_CBCT_FILE = 'cbctFileList'

export const FILE_TYPE_TREATMENT_PLAN = 'treatmentPlanFileList'

export const FILE_TYPE_TREATMENT_PLAN_EXTERNAL = 'treatmentPlanExternalFileList'

export const FILE_TYPE_PRODUCTION = 'productionFileList'

export const FILE_TYPE_CONFORMITY_DECLARATION = 'conformityDeclarationList'

export const FILE_TYPE_CUSTOMS_INVOICE = 'customsInvoiceList'



// WEBPACK FOOTER //
// ./src/modules/customer/state/const.js